<template>
  <div v-if="show" class="connection-error">
    <div class="connection-error-dialog">
      <div class="connection-error-message">
        Unable to connect to server. Please check your internet connection and refresh the page.
      </div>
      <button class="refresh-button" @click="refresh">
        Refresh Page
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectionError',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    refresh() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.connection-error {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.connection-error-dialog {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
  margin: 0 1rem;
}

.connection-error-message {
  margin-bottom: 1rem;
  font-size: 1.1rem;
  color: #333;
}

.refresh-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background: #0056b3;
  }
}
</style>
